var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c("h1", { staticClass: "display-1" }, [_vm._v("New Color")]),
              _vm._v(" "),
              _vm.fabrics
                ? _c("v-select", {
                    attrs: {
                      items: _vm.fabrics,
                      "item-value": "_id",
                      label: "Fabric"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function(data) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(data.item.group.type) +
                                  " - " +
                                  _vm._s(data.item.name) +
                                  "\n        "
                              )
                            ]
                          }
                        },
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(data.item.group.type) +
                                  " - " +
                                  _vm._s(data.item.name) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1802949692
                    ),
                    model: {
                      value: _vm.color.fabric,
                      callback: function($$v) {
                        _vm.$set(_vm.color, "fabric", $$v)
                      },
                      expression: "color.fabric"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Name" },
                model: {
                  value: _vm.color.name,
                  callback: function($$v) {
                    _vm.$set(_vm.color, "name", $$v)
                  },
                  expression: "color.name"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "TWC Name" },
                model: {
                  value: _vm.color.twcName,
                  callback: function($$v) {
                    _vm.$set(_vm.color, "twcName", $$v)
                  },
                  expression: "color.twcName"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Small Image" },
                model: {
                  value: _vm.color.smallImage,
                  callback: function($$v) {
                    _vm.$set(_vm.color, "smallImage", $$v)
                  },
                  expression: "color.smallImage"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Large Image" },
                model: {
                  value: _vm.color.largeImage,
                  callback: function($$v) {
                    _vm.$set(_vm.color, "largeImage", $$v)
                  },
                  expression: "color.largeImage"
                }
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: { label: "Status", checked: "" },
                model: {
                  value: _vm.color.status,
                  callback: function($$v) {
                    _vm.$set(_vm.color, "status", $$v)
                  },
                  expression: "color.status"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", large: "" },
                  on: {
                    click: function($event) {
                      return _vm.addColor()
                    }
                  }
                },
                [_vm._v("Add Colour")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-103e31fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103e31fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/colours/NewColor.vue
// module id = null
// module chunks = 